export default __webpack_public_path__ + "assets/TKO-night-3png.1a0d8cdb.png";